import { Dispatch } from 'redux';
import { ActionType, SearchActionType } from '../search/types';
import { StudentAPI } from '../../api/student-api';
import { dispatchError } from '../search/actions'; 

export const listwalkin = (classId: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SearchActionType.QUERY_LOADING
    });
    StudentAPI.listwalkin(classId).then(function (response) {
        dispatch({
            type: SearchActionType.QUERY_LOADED,
            payload: response.data,
            table: "list_walkin",
            page: "edit_walkin",
            action: ActionType.QUERY
        });
    }, function (error) {
       dispatchError("edit_walkin",dispatch,error);
    })
};

export const savewalkin = (classId: number,item: any) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SearchActionType.QUERY_UPDATING
    });
    StudentAPI.savewalkin(classId,item).then(function (response) {
        dispatch({
            type: SearchActionType.QUERY_UPDATED,
            payload: response.data,
            table: "list_walkin",
            page: "edit_walkin",
            action: ActionType.UPDATE
        });
    }, function (error) {
        if ((error.response!==undefined) && (error.response.status===400)) {
            dispatch({
                type: SearchActionType.QUERY_ERROR,
                page: "edit_walkin",
                payload: error.response.data.additional
            });
        } else 
            dispatchError("edit_walkin",dispatch,error);
    })
};

